import { YearMonthPickerMobile } from '@/domain/termine/components/YearMonthPicker/mobile/YearMonthPickerMobile';
import { List } from '@/domain/termine/features/Calendar/List';
import { YearMonthParams } from '@/domain/termine/type';
import { useParams } from 'react-router-dom';

export function TermineMobileContent() {
  const { year, month } = useParams();
  const currentMonthAndYear: YearMonthParams = {
    year: year ?? '',
    month: month ?? '',
  };
  return (
    <>
      <div className="sticky top-0 z-10 bg-white">
        <YearMonthPickerMobile currentMonthAndYear={currentMonthAndYear} />
      </div>
      <div className="p-4">
        <List />
      </div>
    </>
  );
}
